import { createRouter, createWebHistory } from "vue-router"
import { useAuthStore } from "@/store/authStore.js"
import Dashboard from "../views/Dashboard.vue"
import Login from "../views/Login.vue"

const routes = [
  // TODO: check si es mejor ésto, o el login directo en home
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/reestablecer",
    name: "Reestablecer",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/PasswordRecovery.vue"),
  },
  {
    path: "/newpassword/:token?",
    name: "Nuevo Password",
    component: () => import(/* webpackChunkName: "about" */ "../views/NewPassword.vue"),
  },
  /* {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("../views/Dashboard.vue"),
  }, */
  {
    path: "/reservapase/:paseClaseId?",
    name: "ReservaPase",
    component: () => import("../views/ReservaPase.vue"),
    paramas: true,
  },
  {
    path: "/historial",
    name: "Historial",
    component: () => import("../views/Historial.vue"),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from, next) => {
  // redirect to login page if user is not logged in and trying to access a restricted page
  const publicPages = ["Login", "Reestablecer", "Nuevo Password"]
  const authRequired = !publicPages.includes(to.name)
  const isLoggedIn = localStorage.getItem("user") // TODO: I think this is wrong -- I should use the vuex store
  const authStore = useAuthStore()
  // const loggedIn = store.state.user
  // const loggedIn = true

  if (authRequired && !authStore.isLoggedIn) {
    return next("/login")
  }

  next()
})

export default router
